import { Injectable } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BehaviorSubject } from 'rxjs';

@UntilDestroy()
@Injectable({
	providedIn: 'root',
})
export class CmFormErrorService {
	private formsToLog = new BehaviorSubject<{ [key: string]: any | null }>({});
	formsToLog$ = this.formsToLog.asObservable();

	constructor() {}

	registerFormForLogging(key: string, form: FormGroupDirective) {
		if (!this.formsToLog[key]) {
			form.valueChanges.pipe(untilDestroyed(this)).subscribe(value =>
				this.formsToLog.next({
					...this.formsToLog.getValue(),
					...{ [key]: value },
				})
			);
		}
	}

	unregisterFormFromLogging(key: string) {
		const forms = { ...this.formsToLog.getValue() };
		delete forms[key];
		this.formsToLog.next(forms);
	}
}
